// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3ACwe","content":"GlobalSearch_content__2IsG-"};